import { useQuery } from "@tanstack/react-query";
import { resourcesService } from "app/services";

export function useGeneros() {
  const generos = useQuery({
    queryKey: ["generos"],
    queryFn: resourcesService.getGeneros,
  });

  return generos;
}
